module.exports = __webpack_public_path__ + "img/face-smile-wink.8beb1acf.svg";